import {POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listItems = ({pagination, userIds, snapshotDateTime, folderId, searchTerm, type}) => {
  return POST('exchange/chat/search', {
    pagination,
    userIds,
    snapshotDateTime,
    folderId,
    type,
    searchTerm: trimString(searchTerm)
  });
}

const listChatBreadcrumps = ({userId, folderId, snapshotDate}) => {
  return POST('exchange/chat/breadcrumbs', {userId, folderId, snapshotDate})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, selectedIds, code}) => {
  return POST('exchange/chat/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('exchange/chat/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    snapshotId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null})
}

export {
  listItems,
  listChatBreadcrumps,
  exportSnapshot,
  restoreSnapshot
}
